import { browserTracingIntegration as browserTracingIntegration$1 } from '@sentry/react';
import { setGlobals, startPageloadSpan } from './performance.js';

/**
 * Creates a browser tracing integration for Remix applications.
 * This integration will create pageload and navigation spans.
 */
function browserTracingIntegration(options) {
  if (options.instrumentPageLoad === undefined) {
    options.instrumentPageLoad = true;
  }

  if (options.instrumentNavigation === undefined) {
    options.instrumentNavigation = true;
  }

  setGlobals({
    useEffect: options.useEffect,
    useLocation: options.useLocation,
    useMatches: options.useMatches,
    instrumentNavigation: options.instrumentNavigation,
  });

  const browserTracingIntegrationInstance = browserTracingIntegration$1({
    ...options,
    instrumentPageLoad: false,
    instrumentNavigation: false,
  });

  return {
    ...browserTracingIntegrationInstance,
    afterAllSetup(client) {
      browserTracingIntegrationInstance.afterAllSetup(client);

      if (options.instrumentPageLoad) {
        startPageloadSpan();
      }
    },
  };
}

export { browserTracingIntegration };
//# sourceMappingURL=browserTracingIntegration.js.map
